// src/packages/viriyah/motor/viriyah_ev_type1_2to5/EVType1Card.jsx
import React from "react";
import "./ev_type1.css";

export default function EVType1Card({ onSelect }) {
  return (
    <div className="pkg-card viriyah-ev">
      <div className="pkg-body">
        <h3>วิริยะ EV ชั้น 1 (2–5 ปี)</h3>
        <p>ซ่อมห้าง • ครอบคลุมรุ่นฮิต BYD, ORA, MG, TESLA, VOLVO, BMW</p>

        <ul className="pkg-list">
          <li>กำหนดทุน ~80% ของราคารถ (มาตรฐานโรงงาน)</li>
          <li>รวมส่วนลด CCTV และแอปแจ้งเหตุแล้ว</li>
          <li>ต้องระบุผู้ขับขี่ 1–5 คน ตามประกาศ คปภ.</li>
        </ul>

        <button className="pkg-btn" onClick={onSelect}>ดูรายละเอียด</button>
      </div>
    </div>
  );
}
